<script setup>
  import { ref } from 'vue';

  const props = defineProps({
    title: {
      type: String,
      required: false,
      default: ''
    },
    selectedItem : {
      type: String,
      required: false,
      default: ''
    }
  })

  const isOpen = ref(false);

  const toggleMenu = (event) => {
    event.stopPropagation();
    isOpen.value = !isOpen.value;
    if (isOpen.value) {
      document.addEventListener('click', closeMenu);
    }
  };

  const closeMenu = () => {
    isOpen.value = false;
    document.removeEventListener('click', closeMenu);
  };
</script>

<template>
  <div class="dropdown">
    <button type="button" class="btn btn-outline-secondary dropdown-toggle w-100 d-flex justify-content-between align-items-center" @click="toggleMenu">
      {{ selectedItem || title }}
    </button>
    <ul class="dropdown-menu w-100" :class="{ show: isOpen }">
      <slot></slot>
    </ul>
  </div>
</template>
